import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { SiYoutubekids } from "react-icons/si";
import { FaSquareInstagram } from "react-icons/fa6";
import { TfiFacebook } from "react-icons/tfi";
const Footer = () => {
  return (
    <div>
      <footer className="main-footer">
        <div className="container">
          <div className="footer-content">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                <div className="logo-widget footer-widget">
                  <figure className="logo-box">
                    <Link to="/">
                      <img
                        src="/assets/images/Revierradriverlogo.png"
                        className="rounded w-25"
                        alt="Logo"
                      
                      />
                    </Link>
                  </figure>
                  <div className="text">
                    <p>
                      Nous sommes un service de VTC professionnel, offrant des
                      trajets confortables et sûrs à travers la ville. Que ce
                      soit pour une course rapide ou un transport de luxe, nous
                      vous garantissons une expérience de qualité à chaque
                      trajet.
                    </p>
                  </div>
                  <ul className="footer-social">
                    <li>
                      <Link to="https://www.facebook.com">
                        <i className="fab fa-facebook-f">
                          <TfiFacebook />
                        </i>
                      </Link>
                    </li>
                    <li>
                      <Link to="https://youtube.com">
                        <i className="fab fa-twitter">
                          <SiYoutubekids />
                        </i>
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.instagram.com">
                        <i className="fab fa-linkedin-in">
                          <FaSquareInstagram />
                        </i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 offset-lg-2 footer-column">
                <div className="service-widget footer-widget">
           
                  <ul className="list footer-links">
                    <li>
                      <Link to="/">Accueil</Link>
                    </li>
                    <li>
                      <Link to="/about">À propos</Link>
                    </li>
                    <li>
                      <Link to="/services">Nos Services</Link>
                    </li>
              
                    <li>
                      <Link to="/bookingform">Contactez-nous</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 footer-widget">
                <div className="contact-widget footer-widget">
                  <div className="footer-title">Contactez-nous</div>
                  <div className="text-ligh ">
                    <p>+33 661585885</p>
                    <p>
                   <a
  className="text-light text-decoration-none fw-bold"
  href="mailto:revierradriver@gmail.com"
>
  Revierradriver@gmail.com
</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 column">
              <div className="copyright">
                <Link to="/">Revierradriver</Link> &copy; 2025 Tous droits
                réservés
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 column">
              <ul className="footer-nav">
                <li>
                  <Link to="/terms-of-service">Conditions d'utilisation</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Politique de confidentialité</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
